<template>
  <div>
    <div class="head">
      <el-button type="primary" size="small" style="width: 80px" @click="addBtn">新增</el-button>
    </div>
    <div class="content">
      <el-table
          :data="riskObjectList"
          :header-cell-style="{ background: 'rgb(250,250,250)' }"
          style="width: 100%">
        <el-table-column label="风险分析对象名称" align="center" prop="riskObjectName"/>
        <el-table-column label="重大危险源编码" align="center" prop="dsMajorHazards.serialNum"/>
        <el-table-column label="责任部门名字" align="center" prop="dutyDeptName"/>
        <el-table-column label="责任人姓名" align="center" prop="dutyPsnName"/>
        <el-table-column label="责任人联系方式" align="center" prop="dutyPsnTel"/>
        <el-table-column label="创建人" align="center" prop="creator"/>
        <el-table-column label="操作" width="120">
          <template slot-scope="{ row }">
            <span class="btn" style="color: #1890ff" @click="editBtn(row)">编辑</span>
            <span style="margin: 0 5px;color: #e8e8e8">|</span>
            <span class="btn" style="color: #ff0000" @click="deleteBtn(row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 15px">
        <Page :total="total" :current="curPage" :page-size="pageSize" @on-change="pageChange"/>
      </div>
    </div>

    <!-- 添加或修改风险对象管理对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="风险分析对象名称" prop="riskObjectName">
          <el-input v-model="form.riskObjectName" placeholder="请输入风险分析对象名称"/>
        </el-form-item>
        <div style="display: flex; width: 90%;margin: 10px 20px auto auto;">
          <span style="margin: auto 0;color: red;">若当前分析对象关联重大危险源时请选择</span>
        </div>
        <el-form-item label="重大危险源" prop="isRiskObjectCode">
          <el-select v-model="form.dsMajorHazardsId" placeholder="请选择危险源">
            <el-option
                v-for="dict in dsMajorHazardsList"
                :key="dict.id"
                :label="dict.name"
                :value="dict.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="责任部门名字" prop="dutyDeptName">
          <el-input v-model="form.dutyDeptName" placeholder="请输入责任部门名字"/>
        </el-form-item>
        <el-form-item label="责任人姓名" prop="dutyPsnName">
          <el-input v-model="form.dutyPsnName" placeholder="请输入责任人姓名"/>
        </el-form-item>
        <el-form-item label="责任人联系方式" prop="dutyPsnTel">
          <el-input v-model="form.dutyPsnTel" placeholder="请输入责任人联系方式"/>
        </el-form-item>
        <el-form-item label="创建人" prop="creator">
          <el-input v-model="form.creator" placeholder="请输入创建人"/>
        </el-form-item>
        <el-form-item label="数据对接省厅" prop="isTest">
          <el-select v-model="form.isTest" style="width: 100%">
            <el-option :value="1" label="否"/>
            <el-option :value="0" label="是"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {
  listRiskObject,
  getRiskObject,
  delRiskObject,
  addRiskObject,
  updateRiskObject
} from "@/api/doublePrevention/riskObject";
import {hazardInstallationsList} from "@/api/majorHazard"

export default {
  name: 'ProcessRawMaterials',
  data() {
    return {
      // searchContent: '',
      riskObjectList: [],
      dsMajorHazardsList: [],
      total: 0,
      curPage: 1,
      pageSize: 10,
      open: false,
      form: {},
      rules: {},
      title: null
    }
  },
  created() {
    this.getRiskObjectList();
    this.getDsMajorHazardsList();
  },
  methods: {
    getRiskObjectList() {
      listRiskObject({limit: this.pageSize, curPage: this.curPage, type: 0, isPage: 1}).then(res => {
        this.riskObjectList = res.body.data
        this.total = res.body.cum
      })
    },
    getDsMajorHazardsList() {
      hazardInstallationsList().then(res => {
        this.dsMajorHazardsList = res.body.data
      })
    },
    pageChange(val) {
      this.curPage = val;
      this.getRiskObjectList();
    },
    addBtn() {
      this.reset()
      this.open = true
      this.title = '添加风险分析对象管理'
    },
    editBtn(row) {
      this.reset()
      const riskObjectId = row.riskObjectId
      getRiskObject(riskObjectId).then(response => {
        this.form = response.body.data
        this.open = true
        this.title = '修改风险分析对象管理'
      })
    },
    deleteBtn(row) {
      delRiskObject(row.riskObjectId).then(res => {
        this.$message.success('删除成功');
        this.getRiskObjectList();
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 上传图片
    handleAvatarSuccess(res, file) {
      this.$set(this.form, "enterpriseName", res.data);
    },
    // 表单重置
    reset() {
      this.form = {
        riskObjectId: null,
        enterpriseId: null,
        enterpriseName: null,
        companyCode: null,
        createTime: null,
        creator: null,
        recordStatus: null,
        isTest: null,
        dsMajorHazardsId: null,
        dsMajorHazards: null,
        dutyDeptName: null,
        dutyPsnName: null,
        dutyPsnTel: null,
      }
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.form.riskObjectId != null) {
            updateRiskObject(this.form).then(response => {
              this.open = false
              this.getRiskObjectList();
            })
          } else {
            addRiskObject(this.form).then(response => {
              this.open = false
              this.getRiskObjectList();
            })
          }
        }
      })
    },
  }
}
</script>

<style scoped>
.head {
  display: flex;
  justify-content: space-between;
  width: calc(100% - 280px);
}

.btn {
  cursor: pointer;
}
</style>
